import { render, staticRenderFns } from "./VerEnvio.vue?vue&type=template&id=2d00ca1e&scoped=true&"
import script from "./VerEnvio.vue?vue&type=script&lang=js&"
export * from "./VerEnvio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00ca1e",
  null
  
)

export default component.exports